import React from 'react'
import PropTypes from 'prop-types'

import styled from 'styled-components'
import { mapToTheme } from 'styled-map'
import { layout, space } from 'styled-system'

import Flex from 'Components/UI/_Legacy/Flex'
import Text from 'Components/UI/_Legacy/Text'

const Container = styled(Flex).attrs({
  as: 'button',
  py: 1,
  px: ['8px', '12px'],
  alignItems: 'center',
})`
  white-space: nowrap;
  border-radius: 4px;
  cursor: pointer;
  outline: none;
  height: 32px;
  max-width: 325px;
  background-color: ${mapToTheme('colors.white')};
  color: ${mapToTheme('colors.font.primary')};

  border-width: 1px;
  border-style: solid;
  border-color: ${mapToTheme('button.borderColor')};

  :focus,
  :hover {
    background: ${mapToTheme('button.backgroundColorHover')};
  }

  :active {
    background: ${mapToTheme('button.backgroundColorActive')};
  }

  ${space};
  ${layout};
`

export const Label = styled(Text).attrs({
  ml: '6px',
  display: ['none', 'inline-block'],
})`
  font-size: 12px;
  font-weight: 500;
  text-transform: uppercase;
`

const IconButton = ({ icon, children, ...rest }) => (
  <Container {...rest}>
    {icon}
    <Label>{children}</Label>
  </Container>
)

IconButton.defaultProps = {
  children: null,
  icon: null,
}

IconButton.propTypes = {
  children: PropTypes.any,
  icon: PropTypes.any,
}

export default IconButton
